/* tslint:disable */
 
import { ActionOverridableOptions } from './action-overridable-options';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
export class DataReactionAction {
  actionType: 0 | 1 | 2 | 10 | 11 | 12 | 13 | 14 | 15 | 20 | 21 | 22 | 30 | 90 | 100 | 101 | 102 | 103 | 104 | 200;
  description?: null | NullableLocalizedValue;
  id?: string;
  name: LocalizedValue;
  normalizedName: string;
  options: any;
  overridableOptions?: Array<ActionOverridableOptions>;
  resultField?: string;

  [key: string]: any;
}
